import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';

import { auth } from '../firebase/config';
import { useAuth } from '../context/AuthContext';

import PublicHeader from '../components/Header/PublicHeader';
import PublicFooter from '../components/Footer/PublicFooter';
import GoogleLoginButton from '../components/common/GoogleLoginButton';
import Button from '../components/ui/Button';

import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { refreshProfile } = useAuth();

  const selectedPlan = new URLSearchParams(location.search).get('plan');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const userCred = await signInWithEmailAndPassword(auth, email, pass);
      const idToken = await userCred.user.getIdToken();
      await refreshProfile(idToken);

      if (selectedPlan) {
        navigate(`/dashboard?plan=${selectedPlan}`, { replace: true });
      } else {
        navigate('/dashboard', { replace: true });
      }
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <PublicHeader />

      <section className="login-page">
        <div className="container">
          <div className="login-card">
            <h1 className="login-title">Welcome back</h1>
            <p className="login-subtitle">
              Sign in to access your Vaultize dashboard
            </p>

            {error && (
              <div className="login-error" role="alert" aria-live="polite">
                {error}
              </div>
            )}

            <form onSubmit={handleLogin} className="login-form">
              <div className="form-field-group">
                <label htmlFor="login-email" className="sr-only">
                  Work email
                </label>
                <input
                  id="login-email"
                  name="email"
                  className="input"
                  type="email"
                  placeholder="Work email"
                  autoComplete="email"
                  spellCheck={false}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={submitting}
                />
              </div>

              <div className="form-field-group">
                <label htmlFor="login-password" className="sr-only">
                  Password
                </label>
                <input
                  id="login-password"
                  name="password"
                  className="input"
                  type="password"
                  placeholder="Password"
                  autoComplete="current-password"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                  required
                  disabled={submitting}
                />
              </div>

              <Button
                type="submit"
                variant="primary"
                disabled={submitting}
              >
                {submitting ? 'Signing in…' : 'Login'}
              </Button>
            </form>

            <div className="login-divider">OR</div>

            <GoogleLoginButton />

            <div className="login-footer">
              <Link to="/forgot-password">Forgot password?</Link>
              <span>
                Don’t have an account? <Link to="/signup">Sign up</Link>
              </span>
            </div>
          </div>
        </div>
      </section>

      <PublicFooter />
    </>
  );
};

export default Login;
